import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CommonFunctionService {
  constructor() {}
  private closeTabSubject = new Subject<number>();
  public closeTab$ = this.closeTabSubject.asObservable();

  public pub = new Subject<any>();
  public pub$: Observable<any> = this.pub.asObservable();

  testMethod() {
    return "test1111";
  }

  setMiddleEllipsis(text, maxWidth = 150, fontSize = 13) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = `${fontSize}px Arial`;

    let width = context.measureText(text).width;

    if (width <= maxWidth) {
      return text;
    }
    maxWidth = Math.floor(maxWidth - context.measureText("...").width);
    let firstPart = "";
    let secondPart = "";
    let half = Math.floor(maxWidth / 2);
    for (let i = 0; i < text.length; i++) {
      firstPart += text[i];
      width = context.measureText(firstPart).width;
      if (width > half) {
        break;
      }
    }

    for (let i = text.length - 1; i >= 0; i--) {
      secondPart = text[i] + secondPart;
      width = context.measureText(secondPart).width;
      if (width > half) {
        break;
      }
    }

    return firstPart + "..." + secondPart;
  }

  getPureUrl(url: string) {
    if (url) {
      // 如果params的value 携带查询参数， 则截取前面部分
      url = decodeURIComponent(url);
      if (url.includes("?")) {
        url = url.split("?")[0];
      }
    }
    return url;
  }

  // 删除当前
  closeTab(tabIndex?: number) {
    return this.closeTabSubject.next(tabIndex);
  }

  publish(event) {
    this.pub.next(event);
  }

  rtn(str) {
    if (str && (str !== 0 || str !== "0")) {
      let arr = str.trim().split(" ");
      let res = "";
      for (let i = 0; i < arr.length; i++) {
        let el = arr[i];
        if (el) {
          arr[i] = el.replace(/[^a-zA-z0-9\u4e00-\u9fa5]/g, "");
        } else {
          arr.splice(i, 1);
          i--;
        }
      }
      arr = arr.filter((el) => el);
      var pattern = new RegExp("[\u4E00-\u9FA5]+");
      var pattern2 = new RegExp("[A-Za-z0-9]+");
      if (arr.length > 1) {
        if (pattern.test(arr[0][0])) {
          res = arr[0][0];
          return res;
        } else if (pattern2.test(arr[0][0])) {
          if (pattern2.test(arr[1][0])) {
            res = arr[0][0] + arr[1][0];
          } else if (pattern.test(arr[1][0])) {
            res = arr[0][0] + arr[0][1];
          }
          if (res != null && res != "" && typeof res == "string") {
            return res.toUpperCase();
          } else {
            return "";
          }
        }
      } else if (arr.length == 1) {
        if (pattern.test(arr[0][0])) {
          res = arr[0][0];
          return res;
        } else if (pattern2.test(arr[0][0])) {
          if (pattern2.test(arr[0][1])) {
            res = arr[0][0] + arr[0][1];
            if (res != null && res != "" && typeof res == "string") {
              return res.toUpperCase();
            } else {
              return "";
            }
          } else if (pattern.test(arr[0][1])) {
            res = arr[0][1];
            if (res != null && res != "" && typeof res == "string") {
              return res.toUpperCase();
            } else {
              return "";
            }
          }
        }
      }
    } else {
      return "";
    }
  }

  Guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
}
